import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import SignUpApi from 'apis/SignUp';
import { trackEvent } from 'containers/Analytics';
import Login from 'components/LandingPage/Login';
import SignUp from 'components/LandingPage/SignUp';

import logo from 'assets/img/logo.png';
import easySurvey from 'assets/img/easy-survey.png';
import efficientAnalysis from 'assets/img/efficient-analysis.png';
import improvedExperience from 'assets/img/improved-customer-experience.png';
import soonoBusiness from 'assets/img/soono-business.png';
import soonoSurvey from 'assets/img/soono-survey.png';
import 'assets/scss/landingPage.css';
import { ROUTES, TRIAL_SIGNUP_ROUTES } from '../constants/Routes';
import SocialIcons from '../components/LandingPage/SocialIcons';
import UpgradeModal from '../components/Modal/UpgradeModal/UpgradeModal';
import ModalDisplay from '../components/ConfirmationModal/Modal/ModalDisplay';

class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      subscription_email: '',
      password: '',
      loading: false,
    };
    this.subscribe = this.subscribe.bind(this);
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleTopClick() {
    trackEvent({
      category: 'Subscription',
      action: 'Subscribe using top bar',
    });
  }

  handleBottomClick() {
    trackEvent({
      category: 'Subscription',
      action: 'Subscribe using bottom bar',
    });
  }

  subscribe(e) {
    const { subscription_email } = this.state;
    let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let test = pattern.test(subscription_email);
    if (!test) {
      toast.error(() => {
        return (
          <div>
            <FontAwesomeIcon icon="exclamation-triangle" />
            Please provide valid email address.
          </div>
        );
      });
      return;
    }
    SignUpApi.subscribe(subscription_email)
      .then(() => {
        toast.success(() => (
          <div>
            Thank you, email received successfully. We will contact you shortly.
          </div>
        ));
      })
      .catch(e => {
        toast.error(() => {
          return (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              {(e.response && e.response.data.error) ||
                e.message ||
                'Sorry, some error occured'}
            </div>
          );
        });
        console.log(e);
      });
  }

  render() {
    const { subscription_email } = this.state;

    return (
      <div>
        <header className="header">
          <div className="navbar navbar-dark">
            <div className="container d-flex justify-content-between login-form-landing">
              <a
                href="/home"
                className="navbar-brand d-flex align-items-center"
              >
                <img src={logo} title="Soono Logo" alt="Soono Logo" />
              </a>
              <Login />
            </div>
          </div>

          <ModalDisplay/>

          <section className="jumbotron bg-transparent">
            <div className="container">
              <div className="row">
                <div className="col-lg-9 col-md-8">
                  <h1 className="jumbotron-heading text-white mb-4 mt-5">
                    Understand your customers better with <strong>Soono</strong>
                  </h1>
                </div>
                <div className="col-lg-9 col-md-12">
                  <Link
                    style={{ fontWeight: 800 }}
                    className="btn btn-warning btn-lg col-md-9 py-2 pl-3 pr-3 text-white text-bold border-0 col-md-4"
                    to={TRIAL_SIGNUP_ROUTES.CONTACT_DETAILS}
                  >
                    Start your free trial <br></br>
                    <small>Get to know your customer better right now!</small>
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </header>

        <main role="main">
          <div className="soono-features pb-5">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <div className="shadow p-4 bg-white rounded text-center feature-card">
                    <h2>Easy Surveys</h2>
                    <img
                      className="img-fluid mt-4 mb-3"
                      src={easySurvey}
                      alt="Easy Survey"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="shadow p-4 bg-white rounded text-center feature-card">
                    <h2>Efficient Analysis</h2>
                    <img
                      className="img-fluid mt-4 mb-3"
                      src={efficientAnalysis}
                      alt="Efficient Analysis"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="shadow p-4 bg-white rounded text-center feature-card">
                    <h2>Improved Customer Experience</h2>
                    <img
                      className="img-fluid mt-4 mb-3 customer-exp-img"
                      src={improvedExperience}
                      alt="Improved Customer Experience"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section
            id="growBusiness"
            className="soono-welcome sky-blue-bg text-white"
          >
            <svg
              className="svg-bg bottom-curve"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
            >
              <polygon fill="#f5f5f5" points="50,50 0,100 100,100" />
            </svg>
            <svg
              className="svg-bg top-curve"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
            >
              <polygon fill="#f5f5f5" points="50,50 0,100 100,100" />
            </svg>
            <div className="container grow-business">
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <h2 className="mt-5 mb-3">Grow your business with Soono!</h2>
                  <p className="lead">
                    Are you ready to take control of your customer experience?
                    If so, Soono has you covered. No more worrying about Yelp
                    and Google reviews that negatively impact your business and
                    keep you up at night. With Soono, knowing how your customers
                    feel about their experience in the moment gives you the
                    opportunity to change that negative experience to a positive
                    one. Keeping existing customers happy and wowing new
                    customers is a winning formula for any business looking to
                    grow!
                  </p>
                  <p>
                    According to Forrester, 84% of companies aspire to be a
                    customer experience leader, but only 1 out of 5 deliver good
                    or great customer experience. Customers are willing to pay
                    4.5 times more for an excellent customer experience versus a
                    poor customer experience. The operating margin for companies
                    with engaged employees is 4.1 times larger than the margin
                    for companies with non-engaged employees.
                  </p>
                </div>
                <div className="col-lg-6 col-md-12 text-center sm-pb-2">
                  <img
                    className="img-fluid mt-4"
                    src={soonoBusiness}
                    alt="Business with Soono"
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="why-soono">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-4 text-center">
                  <img
                    src={soonoSurvey}
                    className="img-fluid"
                    alt="Soono Survey"
                  />
                </div>
                <div className="col-lg-6 col-md-7 mx-auto">
                  <div className="why-soono-text">
                    <h2>Why Soono?</h2>
                    <ul className="lead">
                      <li>
                        Quick and easy surveys for your customers to take.
                      </li>
                      <li>Real time data, state of the art reporting</li>
                      <li>
                        Data collection, email and phone for future marketing
                      </li>
                      <li>
                        Personalized 1:1 support from Soono representatives
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="sign-up blue-bg text-white">
            <svg
              className="svg-bg bottom-curve"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
            >
              <polygon fill="#f5f5f5" points="50,50 0,100 100,100" />
            </svg>
            <svg
              className="svg-bg top-curve"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
            >
              <polygon fill="#f5f5f5" points="50,50 0,100 100,100" />
            </svg>
            <div className="container">
              <div className="row justify-content-md-center footer-cta">
                <div className="col-lg-7 col-md-8 text-center">
                  <h2 className="mt-4 mb-4">Sign Up to Learn More</h2>
                  <p className="lead">
                    Thank you for your interest in learning more about how you
                    can leverage Soono to provide improved experiences for your
                    customers.
                  </p>
                  <div className="col-lg-10 offset-lg-1 col-md-12 col-sm-12">
                    <Link
                      style={{ fontWeight: 800 }}
                      className="btn btn-warning btn-lg col-sm-12 py-2 pl-3 pr-3 text-white text-bold border-0"
                      to={TRIAL_SIGNUP_ROUTES.CONTACT_DETAILS}
                    >
                      Start your free trial <br></br>
                      <small>Get to know your customer better right now!</small>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <footer className="text-muted pt-4 pb-4">
          <div className="container">
            <div className="row">
              <p className="col-lg-6 col-md-12 col-sm-12 rights-reserved">
                © {new Date().getFullYear()} All rights reserved by{' '}
                <Link to="/home">Soono</Link>.
                <SocialIcons className="col-sm-12" />
              </p>
              <p className="float-right col-lg-6 col-md-12 col-sm-12 footer-links">
                <ul>
                  <li>
                    <a href="#growBusiness">About Us</a>
                  </li>
                  <li>
                    <Link to="/events">Events</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-of-use">Terms and Conditions</Link>
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/containers/LandingPage.js